import { Component } from '@angular/core';

@Component({
  selector: 'app-returns',
  templateUrl: './returns.html',
  styleUrl: './returns.css',
})
export class Returns {}
